import { atom } from "recoil";

const AdminInfo = atom({
    key: "AdminInfo",
    default: "",
});

export default AdminInfo;
